import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  fetching: false,
  data: {}
}

const actions = generateActions('contacts/GET')

export const getContacts = createAction(API_CONST, () => ({
  actions,
  url: 'feedback'
}))

export default handleActions({
  [actions[0]]: state => ({
    ...state,
    data: {},
    fetching: true
  }),
  [actions[1]]: (state, { payload }) => ({
    ...state,
    data: payload,
    fetching: false
  }),
  [actions[2]]: state => ({ ...initial })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/contacts/index.js